import React, { Component } from 'react';
import BlockField from './../BlockField'

var ProfileFiled = React.createClass({

  render: function(){
    var profile = this.props.profile,
        noFields = [
          'createProfile',
          'createdAt',
          'formEnd',
          'historyStatus',
          'id',
          'sfid',
          'specialty',
          'status',
          'updatedAt',
          'validationPhoneNumberSms',
          'validationPhoneStatus'
        ],
        totalFields = 0,
        trueFiels = 0,
        procent,
        oneFieldProcent;

        for (name in profile) {
          totalFields++;
          if(profile[name]) trueFiels++
          for(var i = 0, l = noFields.length; i < l; i++){
            if(name == noFields[i]){
              totalFields--
              if(profile[name]) trueFiels--
            }
          }
        }

        oneFieldProcent = 100 / totalFields;
        procent = (oneFieldProcent * trueFiels).toFixed(1);

        console.log('totalFields', totalFields);
        console.log('trueFiels', trueFiels);


        return(
          <BlockField type="uniteField" data={`Профайл заполнен на ${procent}%`} />
        );

  }
});

export default ProfileFiled;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppAdmin/components/Profile/components/ProfileFiled/index.jsx
 **/